import { Typography, Paper } from "@mui/material";

interface Props {
  patientId: string;
}

export default function PatientIdBadge({ patientId }: Props) {
  return (
    <Paper
      sx={{
        display: "inline-block",
        px: 2,
        py: 1,
        bgcolor: "#e3f2fd",
        borderRadius: 2,
      }}
      elevation={0}
    >
      <Typography
        variant="h5"
        sx={{ fontWeight: 700, fontFamily: "monospace", letterSpacing: 2 }}
      >
        {patientId}
      </Typography>
    </Paper>
  );
}
